import { provideHttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './services/auth.service';
import { RideService } from './services/ride.service';
import { LoginComponent } from './components/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeComponent } from './components/home/home.component';
import { RegisterComponent } from './components/register/register.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';

import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

import { MapboxService } from './services/mapbox.service';
import { TimePipe } from './modules/shared/pipes/timePipe';
import { SharedModule } from './modules/shared/shared.module';
import { RideBookingService } from './services/ride-booking.service';
import { FeedbackComponent } from './components/feedback/feedback.component';

import { CookieService } from 'ngx-cookie-service';
import { LOCALIZED_MAT_DATE_LOCALE_PROVIDER } from './utils/mat-date-locale.provider';
import { FeatureCardComponent } from "./components/home/feature-card/feature-card.component";
import { CompetitionTableComponent } from "./components/home/competition-table/competition-table.component";
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { ToastrModule } from 'ngx-toastr';
import { CompetitionEventsComponent } from './components/home/competition-events/competition-events.component';
import { AboutPageComponent } from './components/about-page/about-page.component';
import { FaqComponent } from './components/faq/faq.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxStripeModule } from 'ngx-stripe';
import { environment } from 'src/environments/environment';
import { NewRideComponent } from './components/new-ride/new-ride.component';
import { ScriptInjectionService } from './services/script.service';
import { provideMatomo, withRouter } from 'ngx-matomo-client';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    RegisterComponent,
    TimePipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatMenuModule,
    MatBottomSheetModule,
    MatDatepickerModule,
    SharedModule,
    FeedbackComponent,
    FeatureCardComponent,
    CompetitionTableComponent,
    CompetitionEventsComponent,
    AboutPageComponent,
    FaqComponent,
    NewRideComponent,
    ToastrModule.forRoot({
      //toastComponent: InfoToastComponent, // custom default toast
      positionClass: 'toast-top-full-width',
      preventDuplicates: false,
      timeOut: 3000
    }),
    NgxStripeModule.forRoot(environment.stripeKey),
  ],
  providers: [
    AuthService,
    MapboxService,
    RideService,
    RideBookingService,
    ScriptInjectionService,
    LOCALIZED_MAT_DATE_LOCALE_PROVIDER,
    provideDateFnsAdapter(), // it implements { provide: MAT_DATE_FORMATS, useValue: MAT_DATE_FNS_FORMATS } under the hood
    provideHttpClient(),
    CookieService,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
        floatLabel: 'never'
      }
    },
    provideMatomo(
      {
        siteId: environment.matomo.siteId,
        trackerUrl: environment.matomo.url,
        requireConsent: 'cookie'
      },
      // Optionally add one or more features:
      withRouter(),
    ),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
